import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'

import { Icon, TextField } from '@mxenabled/mxui'

export interface SearchBoxProps {
  ariaLabel?: string
  cancelAriaLabel?: string
  onChange: (value: string) => void
  placeholder?: string
  searchValue: string
}

const SearchBox: React.FC<SearchBoxProps> = ({
  ariaLabel = 'Search',
  cancelAriaLabel = 'Cancel Search',
  onChange,
  placeholder = 'Search',
  searchValue,
}) => {
  const cancelButton = (
    <IconButton
      aria-label={cancelAriaLabel}
      className="mx-cat-cancel-search-button"
      color="primary"
      onClick={() => onChange('')}
    >
      <Icon name="cancel" size={24} />
    </IconButton>
  )

  return (
    <Box className="mx-cmn-search-box" px={24} py={16}>
      <TextField
        aria-label={ariaLabel}
        name="search"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Icon name="search" size={26} sx={{ color: 'action.active' }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end" sx={{ p: 0 }}>
                {searchValue ? cancelButton : null}
              </InputAdornment>
            ),
            sx: {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.secondary',
                opacity: 0.5,
              },
              '& input::placeholder': { color: 'text.secondary', opacity: 1 },
            },
          },
        }}
        sx={{
          width: '100%',
        }}
        value={searchValue}
      />
    </Box>
  )
}

export default observer(SearchBox)
